module.exports = __webpack_public_path__ + "static/media/downarrowIcon.00e15496.svg";